import React from 'react'

import {truncate} from 'lodash'
import {palette} from 'styled-tools'
import styled from 'styled-components'
import {media} from 'styled-bootstrap-grid'
import CloseLineIcon from 'remixicon-react/CloseLineIcon'
import HistoryLineIcon from 'remixicon-react/HistoryLineIcon'

import {H5, P} from '@festi/common/components/typography'
import {SearchType} from '@festi/common/utils/tagmanager'
import {SEARCH_INPUT_LENGTH} from '@festi/utils/search'

import {HitsContainer} from './QuickSearchHits'
import useAlgoliaSearch from 'src/components/search/redesign/utilites/useAlgoliaSearch'

const Column = styled.div`
  width: 100%;
  padding: 20px;
`

const RemoveButton = styled.button`
  height: 28px;
  border: none;
  background: none;
  transition: all 0.2s;
  cursor: pointer;

  &:focus {
    opacity: 1;
  }

  svg {
    fill: ${palette('blue')};
  }

  span {
    display: none;
    color: ${palette('link')};
  }

  ${media.md`
    opacity: 0;

    svg {
      display: none;
    }
    span {
      display: block;
    }
  `}
`

const HistoryItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  padding: 4px 0;

  &:hover ${RemoveButton} {
    opacity: 1;
  }

  svg {
    color: ${palette('ui50Solid')};
  }
`
const HistoryButton = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 80%;
  border: none;
  background: none;
  cursor: pointer;

  ${P} {
    height: 28px;
    padding-bottom: 2px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`

interface HitsProps {
  handleSubmitQuery: (query: string, type: SearchType) => void
}

export default function SearchHistory({handleSubmitQuery}: HitsProps) {
  const {searchHistory, handleRemoveHistory} = useAlgoliaSearch()

  if (!searchHistory.length) return null

  return (
    <HitsContainer>
      <Column>
        <H5 withGutter>Síðustu leitir</H5>

        {searchHistory.map((item: string, index: number) => (
          <HistoryItem key={index}>
            <HistoryButton
              onClick={() => handleSubmitQuery(item, 'search_history')}
            >
              <HistoryLineIcon size={20} />
              <P>{truncate(item, {length: SEARCH_INPUT_LENGTH})}</P>
            </HistoryButton>

            <RemoveButton onClick={() => handleRemoveHistory(item)}>
              <span>Fjarlægja</span>
              <CloseLineIcon size={20} />
            </RemoveButton>
          </HistoryItem>
        ))}
      </Column>
    </HitsContainer>
  )
}
